export const testimonial = {
    contentTitle:'our testimonials',
    titleA:'What They’re',
    titleB:'Talking About?',
    text:`At Hillrock Resource Ltd, our clients' satisfaction is our top priority. We take pride in delivering high-quality HR and consulting services tailored to
                                 meet the unique needs of each business we partner with. 
                                But don't just take our word for it—here's what our clients have to say about their experience working with us.
                                `,
    clients:[
        {
        userName: `Hon. Robert James R`,
        content:`Working with HILLROCK has been a game-changer for our business. Their expertise and dedication have helped us streamline our HR processes and improve employee engagement.`,
        designation:`Senator`,
    },
    {id:1,
        userName:'',
        content:'',
        designation:'',
    },
    {id:2,
        userName:'',
        content:'',
        designation:'',
    },
    {id:3,
        userName:'',
        content:'',
        designation:'',
    },
]
}